// Module
var code = "<div class=\"headerWithHelpContainer\"> <h2>{{text}}</h2> <span class=\"helpLink\"></span> </div>";
// Exports
export default code;